import { render, staticRenderFns } from "./AttendeesModal.vue?vue&type=template&id=355f63a6&scoped=true&"
import script from "./AttendeesModal.vue?vue&type=script&lang=js&"
export * from "./AttendeesModal.vue?vue&type=script&lang=js&"
import style0 from "./AttendeesModal.vue?vue&type=style&index=0&id=355f63a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355f63a6",
  null
  
)

export default component.exports